<template>
    <div :class="alignment">
        <h1 class="heading black" :class="headingClass" :style="color">{{ title }}</h1>
    </div>
</template>

<script>

export default {
    name: 'Heading',
    data: function() {
        return {
        };
    },
    props: {
        alignment: {
            type: String,
            default: 'text-center'
        },
        title: '',
        routeName: '',
        showLogout: false,
        color: '',
        textCenter: false,
        justTitle: {
            type: Boolean,
            default: false
        },
        headingClass: {
            type: String,
            default: ''
        }
    },
    computed: {
    },
    mounted: function() {
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
